import { getOriginalFunction } from '@sentry/utils';
import { getClient } from '../exports.js';
import { convertIntegrationFnToClass, defineIntegration } from '../integration.js';
var originalFunctionToString;
var INTEGRATION_NAME = 'FunctionToString';
var SETUP_CLIENTS = new WeakMap();

var _functionToStringIntegration = function _functionToStringIntegration() {
  return {
    name: INTEGRATION_NAME,
    setupOnce: function setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString; // intrinsics (like Function.prototype) might be immutable in some environments
      // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)

      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
          var originalFunction = getOriginalFunction(this);
          var context = SETUP_CLIENTS.has(getClient()) && originalFunction !== undefined ? originalFunction : this;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {// ignore errors here, just don't patch this
      }
    },
    setup: function setup(client) {
      SETUP_CLIENTS.set(client, true);
    }
  };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */


var functionToStringIntegration = defineIntegration(_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation

var FunctionToString = convertIntegrationFnToClass(INTEGRATION_NAME, functionToStringIntegration); // eslint-disable-next-line deprecation/deprecation

export { FunctionToString, functionToStringIntegration };